import { t } from 'i18next'

export const BACKORDER_TITLE = t('backorders.title')
